var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WebHead'),_c('div',{staticClass:"main",style:({ height : _vm.pcHeight})},[_vm._m(0),_vm._m(1)]),_c('WebFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-title"},[_c('span',{staticClass:"title1"},[_vm._v("解决流程")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"process"},[_c('img',{attrs:{"src":require("../../assets/img/msolve.png")}})])])
}]

export { render, staticRenderFns }